import client from './client';
import flatten from './flatten';

export default {
  auth: {
    signIn: data => client.post('/auth/sign_in', data),
    signUp: data => client.post('/auth', data),
    validateToken: () => client.get('/auth/validate_token'),
    passwordRecovery: data => client.post('/auth/password', data),
    passwordReset: data => client.put('/auth/password', data),
    logout: () => client.delete('/auth/sign_out'),
    deleteAccount: () => client.delete('/auth'),
    resetTimer: timestamp => client.post('/user_clocks', { timestamp }),
    inviteSupport: email =>
      client.post('/support_invitations', {
        resource: {
          email,
        },
      }),
  },
  users: {
    update: ({ id, data }) => client.put(`/users/${id}`, { resource: data }),
    deleteSupport: id => client.delete(`/users/${id}/support_person`),
  },
  skills: {
    getUserSkills: () => client.get('/skills'),
    deleteSkill: ({ id }) => client.delete(`skills/${id}`),
    addSkill: data => client.post('/skills', data),
    editSkill: ({ id, data }) => client.put(`skills/${id}`, { id, ...data }),
    changeOrder: data => client.put('/skills/change_order', { ...data }),
  },
  journals: {
    getMyJournals: ({ filter, ...params }) => {
      return client.get('/journals', {
        params: flatten({
          resource: {
            filter,
          },
          ...params,
        }),
      });
    },
    getJournalPrompts: () => client.get('/journal_prompts'),
    addNote: ({ data }) => client.post('/journals', { resource: data }),
    editNote: ({ id, data }) =>
      client.put(`journals/${id}`, { resource: data }),
    deleteNote: ({ id }) => client.delete(`/journals/${id}`),
  },
  module: {
    getModule: ({ id }) => client.get(`/programmodules/${id}`),
    getLectureConditions: ({ id }) => client.get(`/lecture_conditions/${id}`),
    fetchStep: id => client.get(`/steps/${id}`),
  },
  moduleSteps: {
    getModuleSteps: id => client.get(`/programmodule_progresses/${id}`),
    submitStep: resource => client.post('/step_progresses', { resource }),
    updateStep: ({ id, resource }) =>
      client.put(`/step_progresses/${id}`, { resource }),
  },
  contactUs: data => client.post('/enquiries', { resource: data }),
  program: {
    getProgram: () =>
      client.get('/program', {
        params: {
          serializer: 'for_dashboard',
        },
      }),
  },
  video: {
    getFavoriteVideos: () => client.get('/favorite_videos'),
    setFavoriteVideo: id => client.post('/favorite_videos', { id }),
    deleteFavoriteVideo: id => client.delete(`/favorite_videos/${id}`),
  },
  resources: {
    getResources: resource =>
      client.get('/resources', { params: flatten({ resource }) }),
  },
  helps: {
    getHelps: filter => client.get('/helps', { params: flatten({ filter }) }),
  },
  recoveryPlan: {
    getRecoveryPlan: () => client.get('/recovery_plan'),
    getSatisfactionQuestions: () =>
      client.get('/user_satisfaction', {
        params: {
          serializer: 'for_asking',
        },
      }),
    submitSatisfaction: answers =>
      client.post('/user_satisfaction', { answers }),
    getRiskQuestions: () =>
      client.get('/user_relapse_risk', {
        params: {
          serializer: 'for_asking',
        },
      }),
    submitRisk: data => client.post('/user_relapse_risk', data),
    getDailyCheck: () => client.get('/daily_checks'),
    getRecoveryStats: filter =>
      client.get('/user_daily_checks/recovery_stats', {
        params: flatten({ filter }),
      }),
    submitDailyCheck: data => client.post('/user_daily_checks', data),
    updateRecoveryPlan: resource => client.put('/recovery_plan', { resource }),
  },
  billing: {
    getSubscriptionPlans: () => client.get('/subscription_plans'),
    getSubscription: data => client.post('/subscriptions', data),
    deleteSubscription: () => client.delete('/subscriptions'),
  },
  staticPages: {
    getPage: name => client.get(`/static_pages/${name}`),
  },
};



// WEBPACK FOOTER //
// ./src/utils/api.js